import { render, staticRenderFns } from "./pillarRight.vue?vue&type=template&id=24b5ea65&"
var script = {}
import style0 from "./pillarRight.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports